import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const capacities = [
  { bpm: '20 BPM', bph: '1,200 BPH', to: '/20-bpm-water-plant', range: '₹12–18 L' },
  { bpm: '24 BPM', bph: '1,440 BPH', to: '/24-bpm-water-plant', range: '₹15–22 L' },
  { bpm: '30 BPM', bph: '1,800 BPH', to: '/30-bpm-water-plant', range: '₹20–28 L' },
  { bpm: '40 BPM', bph: '2,400 BPH', to: '/40-bpm-water-plant', range: '₹28–38 L' },
  { bpm: '60 BPM', bph: '3,600 BPH', to: '/60-bpm-water-plant', range: '₹45–60 L' },
  { bpm: '90 BPM', bph: '5,400 BPH', to: '/90-bpm-water-plant', range: '₹75–95 L' },
  { bpm: '120 BPM', bph: '7,200 BPH', to: '/120-bpm-water-plant', range: '₹1.4–1.6 Cr' },
  { bpm: '200 BPM', bph: '12,000 BPH', to: '/200-bpm-water-plant', range: '₹2.5–3.2 Cr' }
];

export const CapacityStrip = ({ title = 'Mineral Water Plants by Capacity' }) => (
  <section className="py-14 bg-alden-navy" data-testid="capacity-strip">
    <div className="container mx-auto px-4">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-white">{title}</h2>
          <p className="text-white/70 mt-1">Complete turnkey configurations from starter to enterprise scale</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
        {capacities.map((c) => (
          <Link
            key={c.bpm}
            to={c.to}
            className="bg-white/5 border border-white/15 hover:border-alden-green hover:bg-alden-green/20 rounded-xl p-4 text-center transition-all group"
            data-testid={`capacity-card-${c.bpm.replace(' ', '-').toLowerCase()}`}
          >
            <div className="text-xl font-bold text-white group-hover:text-white">{c.bpm}</div>
            <div className="text-xs text-white/60 mt-1">{c.bph}</div>
            <div className="text-xs font-semibold text-emerald-400 mt-2">{c.range}</div>
            <ArrowRight className="w-4 h-4 text-emerald-400 mx-auto mt-2 opacity-0 group-hover:opacity-100 transition-opacity" />
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default CapacityStrip;
